import {
  CalendarCheckIcon,
  CalendarDotsIcon,
  CalendarSlashIcon,
  HideFor,
} from "/App.Components";
import "./ListItemCallForProposals.scss";
import { ReactNode } from "react";
import { LinkProps } from "/Models/Generated/LinkProps";
import { ColorTheme } from "/Models/Models/ColorTheme";
import { createSpreadableBem } from "/Helpers/createBem";

export interface ListItemMetadata {
  firstRow: ReactNode;
  secondRow?: ReactNode;
}

export interface ListItemProps {
  link?: LinkProps;
  heading?: string;
  label?: string;
  iconType: "active" | "expired" | "allocations";
  metadataItems?: ListItemMetadata;
}

const ListItem: React.FC<ListItemProps> = ({
  link,
  iconType,
  heading,
  label,
  metadataItems,
}) => {
  const metadata = metadataItems && Object.keys(metadataItems).length > 0;
  const Icon = {
    active: CalendarDotsIcon,
    expired: CalendarSlashIcon,
    allocations: CalendarCheckIcon,
  }[iconType];

  const bem = createSpreadableBem("list-item-call-for-proposals-norad");
  return (
    <>
      <li {...bem("")}>
        <a href={link?.href} target={link?.target} {...bem("__link")}>
          <div
            {...bem("__icon", {
              "--active": iconType === "active",
              "--expired": iconType === "expired",
              "--allocations": iconType === "allocations",
            })}
          >
            <div {...bem("__icon-desktop")}>
              <Icon size="48" thickness="Light" color={ColorTheme.black} />
            </div>
            <div {...bem("__icon-mobile")}>
              <Icon size="32" thickness="Reg" color={ColorTheme.black} />
            </div>
          </div>

          <div {...bem("__content")}>
            {label && <p {...bem("__label")}>{label}</p>}
            <h3 {...bem("__heading")}>
              <span>{heading}</span>
            </h3>
            {metadata && (
              <div {...bem("__metadata")}>
                {metadataItems.firstRow && (
                  <div {...bem("__metadata__row-1")}>
                    {metadataItems.firstRow}
                  </div>
                )}
                {metadataItems.secondRow && (
                  <div {...bem("__metadata__row-2")}>
                    {metadataItems.secondRow}
                  </div>
                )}
              </div>
            )}
          </div>
        </a>
      </li>
      <HideFor desktop desktopMedium desktopLargeUp wrapperTag={"li"}>
        <div {...bem("__divider")}></div>
      </HideFor>
    </>
  );
};

export default ListItem;
